import "./container6.css";
function Cont6() {
  return (
    <>
      <div id="container6">
        <div id="fix-downside-bg"></div>
        <div id="cont6-upside1">
          <div id="cont6-upside-tx">
            <h1>NEWS LETTER</h1>
            <p>Sign up to receive updates on new products and special offers</p>
            <div id="cont6-upside-input">
              <p>Email*</p>
              <div class="inquiry">
                <div>
                  <input type="email" />
                </div>
                <div>
                  <button>Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Cont6;
